import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'

import {mutations} from '../../../../api/mutations'
import {invalidateSettingsQuery} from '../../../common/providers'
import {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils'

export const MOTHBALLED_STATUS_ID = '3b13affe-559f-4b2e-a9cd-8855faa3c11e'
export const ACTIVE_STATUS_ID = 'ab616a34-3d20-4ecb-94ed-816f33917f54'

export const useUpdateDepartmentStatus = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()

  return useMutation<
    void,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.updateDepartment>[0]
  >({
    mutationFn: mutations.updateDepartment,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSettled: (_data, _error, variables) => {
      invalidateSettingsQuery('upmDepartmentDetails', variables.id)
      invalidateSettingsQuery('upmDepartmentDetails', variables.upmId)
      invalidateSettingsQuery('upmStructure')
    }
  })
}
